module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "txc",
    staticStyle: {
      "margin-left": "20%",
      "margin-right": "20%",
      "margin-top": "50%"
    },
    attrs: {
      "id": "pz3-1"
    }
  }, [_c('i', [_vm._v("This book is dedicated to my mother, Mary Elizabeth Martin, who taught me the value\n\t\t\t\t\tof books before I knew how to read, turn on a television, and locate the front door\n\t\t\t\t\tof my kindergarten classroom.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48141b2a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dedication.vue
// module id = 63
// module chunks = 0